import { render } from "./Programs.vue?vue&type=template&id=4e0c7eb9"
import script from "./Programs.vue?vue&type=script&lang=js"
export * from "./Programs.vue?vue&type=script&lang=js"

import "./Programs.vue?vue&type=style&index=0&id=4e0c7eb9&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__